/**
 * channelsLineup.tsx
 */
import Channel from '@shared/classes/channel';
import ChannelListTemplate from '../../templates/channel/channelsLineup';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { eventsSelector } from '@shared/store/slices/events.slice';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';

export default function ChannelsLineup() {
  const { currentEvents } = useAppSelector(eventsSelector);
  const { currentChannel, favouriteChannels } =
    useAppSelector(channelsSelector);
  const currentParams = useAppSelector(selectCurrentParams);

  // Prefer the channel focused on the previous channels view, if any
  const paramsChannelId = (currentParams as { channel: Channel })?.channel?.id;
  const selectedChannel =
    (paramsChannelId &&
      favouriteChannels?.find(
        (item: Channel) => item.id === paramsChannelId
      )) ||
    currentChannel;
  const currentIndex =
    favouriteChannels?.findIndex(
      (item: Channel) => item.id === selectedChannel?.id
    ) || 0;

  return (
    <>
      {favouriteChannels?.length && (
        <ChannelListTemplate
          channelsData={favouriteChannels}
          currentChannel={selectedChannel}
          currentEvents={currentEvents}
          currentIndex={currentIndex}
        />
      )}
    </>
  );
}
